import api from './api';

export type MfaMethod = 'totp' | 'email';

export interface MfaStatus {
  mfaEnabled: boolean;
  mfaMethod: MfaMethod | null;
  backupCodesRemaining: number;
}

export const mfaApi = {
  getStatus: async (): Promise<MfaStatus> => {
    const res = await api.get<{ success: boolean; data: MfaStatus }>('/auth/mfa/status');
    return res.data.data;
  },

  setupTotp: async (): Promise<{ secret: string; qrCodeDataUrl: string }> => {
    const res = await api.post<{ success: boolean; data: { secret: string; qrCodeDataUrl: string } }>(
      '/auth/mfa/totp/setup'
    );
    return res.data.data;
  },

  confirmTotp: async (code: string): Promise<{ backupCodes: string[] }> => {
    const res = await api.post<{ success: boolean; data: { backupCodes: string[] } }>('/auth/mfa/totp/confirm', {
      code,
    });
    return res.data.data;
  },

  enableEmail: async (): Promise<{ backupCodes: string[] }> => {
    const res = await api.post<{ success: boolean; data: { backupCodes: string[] } }>('/auth/mfa/email/enable');
    return res.data.data;
  },

  disable: async (password: string): Promise<void> => {
    await api.post('/auth/mfa/disable', { password });
  },

  /** Second step of login when the password step returned `requiresMfa: true`. */
  verifyLogin: async (
    challengeToken: string,
    code: string
  ): Promise<{ token: string; user: Record<string, unknown> }> => {
    const res = await api.post<{ success: boolean; data: { token: string; user: Record<string, unknown> } }>(
      '/auth/mfa/verify-login',
      { challengeToken, code }
    );
    return res.data.data;
  },
};
